import { map, join } from 'lodash'
import { ChangeEvent, useState } from 'react'

import { IReward } from '../../../common/models/rewards'
import { formatDate } from '../../../core/constants'
import { MessageBox } from '../messages/MessageBox'
import { CoinVoucher } from '@/core/services/voucher'
import { IColumn, Table } from '@/core/components/Table'
import { TableSearchParams } from '@/home/components/tickets/generate-tickets/GenerateTicketsListPage'
import { sanitizeDate } from '@/core/constants/times'
import { Button } from '@/components/ui'

export interface RedeemVouchersTableProps {
  data: CoinVoucher[]
  sortBy: string
  setSortBy: (sort: string) => void
  handleSearchParams: (column: IColumn, query: string | null) => void
  onViewVoucher?: (voucher: CoinVoucher) => void
}

export const RedeemVouchersTable = (
  props: RedeemVouchersTableProps,
): JSX.Element => {
  const [isCheckAll, setIsCheckAll] = useState(false)
  const [isCheck, setIsCheck] = useState<string[]>([])

  const [isError, setIsError] = useState<boolean>(false)
  const [errorStatus, setErrorStatus] = useState<number | undefined>(undefined)
  const [showMessageBox, setShowMessageBox] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')

  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll)
    setIsCheck(props.data.map((one) => one.id))
    if (isCheckAll) {
      setIsCheck([])
    }
  }

  const { sortBy, setSortBy, handleSearchParams, onViewVoucher } = props

  const handleClick = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target
    setIsCheck([...isCheck, id])
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id))
    }
  }

  const handleSortBy = (sort: string) => {
    if (sort === sortBy) {
      setSortBy('id')
    } else {
      setSortBy(sort)
    }
  }

  const handlePublishSingle = async (items: string[]) => {
    try {
      console.log(items)
      setIsCheck([])
      // const { status } = await publishStages(isCheck)
      // const response = await getAllStages({ sortBy, size })
      // setStages(response.data.content)
      // if (status === 200 && response.status === 200) {
      //   setIsError(false)
      //   setShowMessageBox(true)
      //   setMessage('Publish Successful')
      // }
    } catch (e) {
      if (e instanceof Error) {
        setIsError(true)
        setShowMessageBox(true)
        setMessage(e.message)
        setErrorStatus(
          (e as { response?: { status?: number } })?.response?.status,
        )
      } else {
        console.error(e)
      }
    } finally {
    }
  }

  const handleUnpublishSingle = async (items: string[]) => {
    try {
      console.log(items)
      setIsCheck([])
      // const { status } = await publishStages(isCheck)
      // const response = await getAllStages({ sortBy, size })
      // setStages(response.data.content)
      // if (status === 200 && response.status === 200) {
      //   setIsError(false)
      //   setShowMessageBox(true)
      //   setMessage('Unpublish Successful')
      // }
    } catch (e) {
      if (e instanceof Error) {
        setIsError(true)
        setShowMessageBox(true)
        setMessage(e.message)
        setErrorStatus(
          (e as { response?: { status?: number } })?.response?.status,
        )
      } else {
        console.error(e)
      }
    } finally {
    }
  }

  const columns: IColumn[] = [
    {
      title: 'Id',
      accessor: 'id',
      sortable: true,
      render: (row: CoinVoucher) => row.id.substring(0, 8),
    },
    {
      title: 'Name',
      accessor: 'name',
      searchable: false,
      render: (row: CoinVoucher) => row.label,
    },
    {
      title: 'Redeem Code',
      accessor: 'redeemCode',
      searchable: true,
      render: (row: CoinVoucher) => row.redeemCode,
    },
    {
      title: 'Generated Date',
      accessor: 'generatedDate',
      render: (row: CoinVoucher) => sanitizeDate(new Date(row.createdAt)),
    },
    {
      title: 'Sent To',
      accessor: 'forEmail',
    },
    {
      title: 'Used',
      accessor: 'used',
      render: (row: CoinVoucher) =>
        `${row.usages} / ${row.unlimited ? 'unlimited' : row.voucherLimit}`,
    },
    {
      title: 'Value',
      accessor: 'value',
      render: (row: CoinVoucher) => `${row.amount} RHUNA`,
    },
    {
      title: 'View',
      accessor: 'view',
      render: (row: CoinVoucher) => (
        <a
          className="view text-accent-1 underline"
          href="#"
          onClick={async (e) => {
            e.preventDefault()
            onViewVoucher?.(row)
          }}
        >
          View
        </a>
      ),
    },
  ]

  return (
    <>
      <Table
        className="[&_th]:!whitespace-nowrap"
        columns={columns}
        data={props.data}
        handleSortBy={handleSortBy}
        handleSearch={handleSearchParams}
      />

      <MessageBox
        message={message}
        setShowMessageBox={setShowMessageBox}
        showMessageBox={showMessageBox}
        isError={isError}
        errorStatus={errorStatus}
      />
    </>
  )
}
